export const formatNumber = (value: number, digits = 2) =>
  value.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: digits })

export const formatKwh = (value: number) => `${formatNumber(value)} kWh`

/** Valores grandes viram MWh para facilitar a leitura nos cards. */
export const formatEnergy = (value: number | null | undefined) => {
  if (value === null || value === undefined) return '—'
  if (Math.abs(value) >= 10000) return `${formatNumber(value / 1000, 2)} MWh`
  return formatKwh(value)
}

export const formatPercent = (value: number | null | undefined) =>
  value === null || value === undefined ? '—' : `${formatNumber(value, 1)}%`

/** Mesma faixa de cores usada para desempenho: abaixo de 80% ruim, até 95% atenção. */
export const performanceColor = (value: number | null | undefined) => {
  if (value === null || value === undefined) return 'secondary'
  if (value < 80) return 'danger'
  if (value < 95) return 'warning'
  return 'success'
}
